import { ArrowLeftOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Table, Tooltip } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Link, useHistory } from "react-router-dom";
import TlogTab from "./tlog_tab";
import TlogTableView from "./tlog_table_view";
import { logDataHelperFunctions } from "../../helpers/logdata-helper";
import { hasEditPermission } from "../../helpers/rabc-helper";
import { EXCLUDED_TLOG_SAGA } from "../../redux/data360Live_PQR/types";
import { CHECKED_TLOG_DATA } from "../../redux/pqrReportData/types";
import EditWeldNumberModal from "../data360_live_slog/EditWeldNumberModal";

const TlogData = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("TableView");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [newWeldNumber, setNewWeldNumber] = useState("");
  const [adminPassword, setAdminPassword] = useState("");
  const location = useLocation();
  const {
    stationNumbers,
    buyType,
    torch,
    type,
    zone,
    view,
    tilt_start,
    tilt_end,
    weld_number,
    s_deviceid_event,
    //tlog display
    autoIncrement,
    band_diameter,
    logging_distance,
    bug_number,
    wire_diameter,
    pipe_diameter,
    start_time,
    end_time,
    weld_time,
    // gps,
    rawZone,
    // iwm,
    // tilt_start,
    // tilt_end,
    isM500,
    rawZoneView,
  } = location.state || {};
  const { weld_no, Bugtype, deviceid, weldNumber, bugTypepqr, passn } =
    location.state || {};
  const queryParams = new URLSearchParams(location.search);
  let boundary = queryParams.get("boundary");
  const dispatch = useDispatch();
  const history = useHistory();
  boundary = boundary ? Number(boundary) : null;
  const hasData = weld_no && Bugtype && deviceid;

  const number = (stationNumbers || "").match(/\d+/)?.[0];
  const station_number = number ? Number(number) : 0;
  const currentProject = useSelector(
    (state) => state?.data360LiveProjectReducer?.currentProject
  );
  const pqrReport = useSelector(
    (state) => state?.data360LivePqrReducer?.reportsInfo?.pqrReport
  );
  const reducerList = useSelector((state) => state);

  const canEdit = hasEditPermission(reducerList?.auth?.userDetails);

  const columns = [
    {
      title: t("tlogData.bugno"),
      dataIndex: "bugNumber",
      key: "bugNumber",
    },
    {
      title: `${t("tlogData.bandDiameter")}${
        currentProject?.units?.band_diameter
          ? `(${currentProject.units.band_diameter})`
          : ""
      }`,
      dataIndex: "bandDiameter",
      key: "bandDiameter",
    },
    {
      title: `${t("tlogData.wirediameter")}${
        currentProject?.units?.wire_diameter
          ? `(${currentProject.units.wire_diameter})`
          : ""
      }`,
      dataIndex: "wireDiameter",
      key: "wireDiameter",
    },
    {
      title: `${t("tlogData.loggingdistance")}${
        currentProject?.units?.logging_distance
          ? `(${currentProject.units.logging_distance})`
          : ""
      }`,
      dataIndex: "loggingDistance",
      key: "loggingDistance",
    },
    {
      title: `${t("tlogData.pipediameter")}${
        currentProject?.units?.pipe_diameter
          ? `(${currentProject.units.pipe_diameter})`
          : ""
      }`,
      dataIndex: "pipeDiameter",
      key: "pipeDiameter",
    },
    {
      title: t("tlogData.autoIncrement"),
      dataIndex: "autoIncrement",
      key: "autoIncrement",
    },
    {
      title: t("tlogData.weldstarttime"),
      dataIndex: "weldStartTime",
      key: "weldStartTime",
    },
    {
      title: t("tlogData.Weldendtime"),
      dataIndex: "weldEndTime",
      key: "weldEndTime",
    },
    {
      title: t("tlogData.weldtime"),
      dataIndex: "weldTime",
      key: "weldTime",
    },
  ];

  const data = [
    {
      key: 1,
      bugNumber: bug_number,
      bandDiameter: band_diameter,
      wireDiameter: wire_diameter,
      loggingDistance: logging_distance,
      pipeDiameter: pipe_diameter,
      autoIncrement: autoIncrement,
      weldStartTime: logDataHelperFunctions.formatWeldStartTimeLive(
        start_time,
        false,
        false,
        true
      ),
      weldEndTime: logDataHelperFunctions.formatWeldStartTimeLive(
        end_time,
        false,
        false,
        true
      ),
      weldTime: weld_time,
    },
  ];

  const excludedTlogsValues = useMemo(() => {
    const excludedTlogsArray =
      pqrReport?.excluded_tlogs_key?.excluded_tlogs || [];
    const matchingItem = excludedTlogsArray.find(
      (item) =>
        item.pass_name?.trim() === passn?.trim() &&
        item.torch?.trim() === Bugtype?.trim() &&
        item.weld_number == weld_no &&
        item?.weld_uuid === s_deviceid_event
    );

    return matchingItem?.excluded_tlogs || [];
  }, [pqrReport, passn, Bugtype, weld_no, s_deviceid_event]);

  const [selectedRowKeys, setSelectedRowKeys] = useState(excludedTlogsValues);
  useEffect(() => {
    console.log("inside use effect --- ", excludedTlogsValues);
    setSelectedRowKeys(excludedTlogsValues);
  }, [excludedTlogsValues]);

  const [isGenerating, setIsGenerating] = useState(false);

  const handleEditButtonClick = () => {
    setIsEditModalOpen(true);
    setNewWeldNumber("");
    setAdminPassword("");
  };

  const handleModalClose = () => {
    setIsEditModalOpen(false);
    setNewWeldNumber("");
    setAdminPassword("");
  };

  const handleModalConfirm = () => {
    setIsEditModalOpen(false);
    setNewWeldNumber("");
    setAdminPassword("");
  };

  const handleAssignButtonClick = () => {
    setIsGenerating(true);

    const existingExcludedTlogs =
      pqrReport?.excluded_tlogs_key?.excluded_tlogs || [];

    const currentExcludedTlogs = {
      pass_name: passn || "",
      torch: Bugtype || "",
      weld_number: weld_no || "",
      excluded_tlogs: selectedRowKeys || "",
      weld_uuid: s_deviceid_event || "",
    };

    const filteredExistingTlogs = existingExcludedTlogs.filter(
      (item) =>
        !(
          item.pass_name?.trim() === passn?.trim() &&
          item.torch?.trim() === Bugtype?.trim() &&
          item.weld_number == weld_no &&
          item?.weld_uuid === s_deviceid_event
        )
    );

    const mergedExcludedTlogs = [
      ...filteredExistingTlogs,
      currentExcludedTlogs,
    ];

    const payload = {
      project_id: currentProject?.project_id,
      excluded_tlogs: mergedExcludedTlogs,
      weld_numbers: weldNumber,
      boundary: boundary,
    };

    dispatch({
      type: EXCLUDED_TLOG_SAGA,
      payload,
      cb: () => {
        setIsGenerating(false);
        // history.push(`/pqr-table-data/${weldNumber}?boundary=${boundary}`);
        history.push({
          pathname: `/data360-live-pqr-table-data/${weldNumber}`,
          search: `?boundary=${boundary}`,
          state: { isGenerating: true },
        });
        dispatch({ type: CHECKED_TLOG_DATA, payload: mergedExcludedTlogs });
      },
    });
  };

  let checkedexcludedTlogsArray = [];

  try {
    const excludedTlogsKeyObject = pqrReport?.excluded_tlogs_key || "{}";

    const { pass_name, torch, weld_number, excluded_tlogs } =
      excludedTlogsKeyObject.excluded_tlogs_key?.[0] || {};

    checkedexcludedTlogsArray =
      pass_name || torch || weld_number || excluded_tlogs
        ? [{ pass_name, torch, weld_number, excluded_tlogs }]
        : [];
  } catch (error) {
    console.error("Error parsing excluded_tlogs_key:", error);
  }

  return (
    <div>
      <div className="slogweld-title">
        {!hasData ? (
          <>
            <Link to={"/data360Live"}>
              <div className="back_equip">
                <Tooltip title={"Back"}>
                  <ArrowLeftOutlined />
                </Tooltip>
                <h2 className="slogweld-header-active">Log Data</h2>
              </div>
            </Link>
            <Link to={`/data360-live-views/${weld_number}`}>
              <div className="back_equip">
                <Tooltip title={"Back"}>
                  <ArrowLeftOutlined />
                </Tooltip>
                <h2 className="slogweld-header-active">Weld {weld_number}</h2>
              </div>
            </Link>
            <div className="back_equip-unActive">
              <ArrowLeftOutlined />
              <h2 className="slogweld-header">
                {stationNumbers} : {buyType}
                {torch ? ` | ${torch}` : ""}
                {zone ? ` : ${zone}` : ""}
              </h2>
            </div>
          </>
        ) : (
          <>
            <Link to={"/data360Live/pqr-report"}>
              <div className="back_equip">
                <Tooltip title={"Back"}>
                  <ArrowLeftOutlined />
                </Tooltip>
                <h2 className="slogweld-header-active">PQR Report</h2>
              </div>
            </Link>
            <Link
              to={{
                pathname: `/data360-live-pqr-table-data/${weldNumber}`,
                search: `?boundary=${boundary}`,
                state: { checkedexcludedTlogsArray },
              }}
            >
              <div className="back_equip">
                <Tooltip title={"Back"}>
                  <ArrowLeftOutlined />
                </Tooltip>
                <h2 className="slogweld-header-active">Weld {weldNumber}</h2>
              </div>
            </Link>
            <Link
              to={{
                pathname: `/data360-live-wps-limit-table`,
                search: `?boundary=${boundary}`,
                state: { passname: passn, weld_number: weldNumber },
              }}
            >
              <div className="back_equip">
                <Tooltip title={"Back"}>
                  <ArrowLeftOutlined />
                </Tooltip>
                <h2 className="slogweld-header-active">{passn}</h2>
              </div>
            </Link>
            <div className="back_equip-unActive">
              <ArrowLeftOutlined className="arrowSpace" />
              <h2 className="slogweld-header-last">
                {weld_no} : {Bugtype == "iwm" ? "" : Bugtype + " : "}{" "}
                {bugTypepqr}
              </h2>
            </div>
          </>
        )}
        <div className="tlognavigatebtn">
          {hasData ? (
            <>
              {canEdit && (
                <Button
                  type="primary"
                  className={selectedRowKeys?.length > 0 ? "assign" : "disable"}
                  onClick={handleAssignButtonClick}
                  disabled={!selectedRowKeys?.length || isGenerating}
                >
                  Generate
                </Button>
              )}
            </>
          ) : (
            <>
              {canEdit && (
                <Button
                  type="primary"
                  className="edit-btn-icon"
                  onClick={handleEditButtonClick}
                >
                  <EditOutlined className="edit-icon" /> Edit
                </Button>
              )}
            </>
          )}
          {activeTab === "TableView" && boundary ? <></> : ""}
        </div>
      </div>
      <>
        {!hasData ? (
          <div className="tlog-detail-bar">
            <Table columns={columns} dataSource={data} pagination={false} />
          </div>
        ) : null}
      </>
      {!hasData ? (
        <TlogTab
          setActiveTab={setActiveTab}
          s_deviceid_event={s_deviceid_event}
          station_number={station_number}
          view={view}
          torch={torch}
          zone={zone}
          tilt_start={tilt_start}
          tilt_end={tilt_end}
          rawZone={rawZone}
        />
      ) : (
        <TlogTableView
          weld_number={weld_number}
          zone={zone}
          type={type}
          s_deviceid_event={s_deviceid_event}
          station_number={station_number}
          boundary={boundary}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          tilt_start={tilt_start}
          tilt_end={tilt_end}
          isM500={isM500}
          rawZoneView={rawZoneView}
          view={view}
          isFromPQRTab={hasData}
        />
      )}

      <EditWeldNumberModal
        open={isEditModalOpen}
        weldNumber={weld_number || weldNumber}
        newWeldNumber={newWeldNumber}
        setNewWeldNumber={setNewWeldNumber}
        adminPassword={adminPassword}
        setAdminPassword={setAdminPassword}
        onCancel={handleModalClose}
        onConfirm={handleModalConfirm}
        projectId={currentProject?.project_id}
        weldUid={s_deviceid_event}
        useUidApi={true}
      />
    </div>
  );
};

export default TlogData;
